import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import { GraphExplorer } from 'dashboard/models/graph-explorer';

/**
 * A wrapper that knows how to produce an iterator over things within its
 * layer so other things can query it.
 */
export class Layer {
  protected graphExplorer: GraphExplorer;
  protected g6Wrapper: G6Wrapper;
  protected x: number;
  protected y: number;
  protected canvasX: number;
  protected canvasY: number;
  protected canvasBBox: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };

  constructor(
    g6Wrapper: G6Wrapper,
    graphExplorer: GraphExplorer,
    x: number,
    y: number,
    canvasX: number,
    canvasY: number,
    canvasBBox: { top: number; right: number; bottom: number; left: number },
  ) {
    this.graphExplorer = graphExplorer;
    this.g6Wrapper = g6Wrapper;
    this.x = x;
    this.y = y;
    this.canvasX = canvasX;
    this.canvasY = canvasY;
    this.canvasBBox = canvasBBox;
  }
}
